export default __webpack_public_path__ + "static/media/MSSolution-modern.6eb88a4e.svg";